import { Setter } from "../../services/ComService";
import TimelineDTO, { ITimeline } from "./TimelineDTO";

const VacationTypeId = 1 // The ID of Vacation is 1 in the API
const VacationSetStatusId = 2

export default class AvailablityDTO extends TimelineDTO {

  constructor(data: IAvailablityDTO) {
    super({
      ...data,
      typeId: VacationTypeId,
      filterByTagsKind: 'availablityCategories'
    })
  }
  async createAvailablity(trainerId: number, dateRange: Date[], tagId: number) {
    if (trainerId < 0) {
      return {
        code: false,
        key: 'noTrainerId',
        message: 'No trainer selected',
      }
    }
    if (dateRange.length !== 2) {
      return {
        code: false,
        key: 'invalidDateRange',
        message: 'Invalid date range',
      }
    }
    // Test if there is already a vacation for trainerId in dateRange
    const existingAvailablity = this.items.find(i => {
      if (i.personId === trainerId &&
      i.fromDate &&
      i.untilDate) {
        // Zeitpunkte definieren:
        const A = dateRange[0].getTime()
        const B = dateRange[1].getTime()
        const a = i.fromDate.getTime()
        const b = i.untilDate.getTime()
        if (
          // Ende von i in Interval
          (A <= b && b <= B) ||
          // Anfang von i in Interval
          (A <= a && a <= B) ||
          // Anfang von i vor Interval und Ende von i nach Interval
          (a < A && B <= b)
        ) { return true }
      }
      return false
    }
      
    )
    if (existingAvailablity) {
      return {
        code: false,
        key: 'vacationExistsInInterval',
        message: 'Vacation for trainer already exists in this time range',
      }
    }
    
    // Try to create vacation with api
    const result = await Setter('timeline', {
      fromDate: dateRange[0],
      untilDate: dateRange[1],
      stpersonId: trainerId,
      type: VacationTypeId,
      status: VacationSetStatusId,
      tagIDs: [tagId],
    }, {
      retryName: `createVacation-${trainerId}-${dateRange[0].toUTCString()}-${dateRange[1].toUTCString()}`
    })
    return result
  }
}

export interface IAvailablityDTO {

}
